/**
 * Share job order text/files to LINE with liff.shareTargetPicker.
 * The server parks the LINE messages in ctr.line_share (/job-order/createLineShare) and
 * returns the LIFF URL (liff.emilytms.com/share?t=...) that opens the chat picker.
 *
 * Call it straight from the click handler: the window is opened before the request so the
 * popup blocker treats it as a user action.
 *
 * @param {object} ax       GlobalStateContext axios instance
 * @param {object} postData { JobOrdIds, Files: [{ Src: 'JO', JobOrdId, FileNm } | { Src: 'PC', PCItmId, FileNm }], msg, Bkg }
 */
export const openLineShare = (ax, postData) => {
  const win = window.open("", "lineShare", "width=520,height=860")
  ax.post("/job-order/createLineShare", postData).then(value => {
    if (value.data) {
      if (win) win.location.href = value.data.Url
      else window.open(value.data.Url, "_blank")
    } else {
      win?.close()
    }
  }).catch(() => win?.close())
}
